
import React, {
  useEffect,
  useRef,
  useState,
  useContext
} from "react";
import { useLocation, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import PageAds from "../../common/pageAds";
import ComedyBreadCrumb from "../comedyBreadCrumb";
import ComedyContentsCard from "./card";
import Skeleton from "../skeleton";
import { DeviceContext } from "..";

import "../../../styles/comedyContents.css";

const ComedyContentsCat = ({ data }) => {

  /* ---------------- SSR DATA ---------------- */
  const ssrData = 
  data?.[0]?.contentsPage ||
   {};
  const ssrCards = ssrData.catData || [];
  const ssrCatId = ssrData.ssrCatId;

  /* ---------------- STATE ---------------- */
  const [dataList, setDataList] = useState(ssrCards);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hydrating, setHydrating] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages] = useState(40);

  const { mobile, setMobile,containerRef } = useContext(DeviceContext);

  /* ---------------- ROUTE ---------------- */
  const location = useLocation();
  const address = location.pathname;

  const matchId = address.match(/-(\d+)\.html$/);
 const catId = matchId ? matchId[1] : null;

  /* ---------------- REFS ---------------- */

  const catIdRef = useRef(catId);
   const isFirst = useRef(true)
  /* ---------------- HELPERS ---------------- */
  const isTelugu = (text) => /[\u0C00-\u0C7F]/.test(text);

  /* ---------------- HYDRATION ---------------- */
  useEffect(() => {
    const t = setTimeout(() => setHydrating(false), 500);
    return () => clearTimeout(t);
  }, []);

  /* ---------------- BREADCRUMB ---------------- */

    
 const CONTENTS_CATEGORIES = [
  { id: 1168, text: "Facebook Fun" },
  { id: 80, text: "Comedy" },
  { id: 23, text: "Jokes" },
  { id: 640, text: "Brahmanandam Jokes" },
  { id: 1135, text: "Three-in-One" },
  { id: 1134, text: "Fun Corner" },
  { id: 1053, text: "My Dear Romeo" },
  { id: 942, text: "Cheapey Rayudu" },
  { id: 941, text: "Silly Fellow" },
  { id: 933, text: "Hello Wrong Number" },
  { id: 654, text: "Fun Time" },
  { id: 24, text: "Audio Serial" },
  { id: 758, text: "Taataadhithai Tadiginatom" },
  { id: 709, text: "Aahanagar Colony" },
  { id: 707, text: "Saddam Aunty Inti Katha" },
  { id: 669, text: "Audio Jokes" },
  { id: 659, text: "Wife and Husband Jokes" },
  { id: 657, text: "General Jokes" },
  { id: 661, text: "Sports Jokes" },
  { id: 655, text: "Political Jokes" },
  { id: 660, text: "Youth and Romantic Jokes" },
  { id: 658, text: "Software and IT Jokes" },
  { id: 642, text: "Shivatandavam" },
  { id: 641, text: "Mallikkrazy" },
  { id: 623, text: "Ammo Ammayilu" },
  { id: 538, text: "Antera Bamardee" },
  { id: 340, text: "Yeluka Vacche Illu Bhadram" },
  { id: 5, text: "Maliks" },
  { id: 319, text: "Sampurna Golayanam" },
  { id: 284, text: "The Diary of LEKHA GUMMADI" },
  { id: 282, text: "Audio Serial" },
  { id: 61, text: "Games" },
  { id: 60, text: "Rampandu Leelalu" },
  { id: 62, text: "Puzzle" },
  { id: 3, text: "Daily Serials" },
  { id: 26, text: "Hot Shot" },
  { id: 27, text: "Tingu" },
  { id: 34, text: "Comedy Stories" },
  { id: 28, text: "Oo Mallikanna" },
  { id: 25, text: "Siggu Siggu" },
  { id: 29, text: "Gura Vayanam" },
  { id: 20, text: "Andaru Dongale" },
  { id: 6, text: "Audio Cartoons" },
  { id: 21, text: "Prema Pandem" },
  { id: 4, text: "Articles" }
];

const breadCrumb = React.useMemo(() => {
  const match = CONTENTS_CATEGORIES.find(
    item => String(item.id) === String(catId)
  );

  return match
    ? { one: match.text, two: "" }
    : { one: "", two: "" };
}, [catId]);


  /* ---------------- CATEGORY CHANGE ---------------- */
  useEffect(() => {
    if (catIdRef.current !== catId) {
      catIdRef.current = catId;
      setPage(1);
      setDataList([]);
      setError(null);
    }
  }, [catId]);

  /* ---------------- DATA FETCH ---------------- */
  useEffect(() => {

    
    if (dataList && catIdRef.current === ssrCatId && page === 1 && isFirst.current) {
      setLoading(false);
     
      return;
    }


    else if (dataList && catIdRef.current === ssrCatId && page === 1 ) {
      setLoading(false);
      setDataList(dataList)
     
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        setMobile(window.innerWidth <= 768);
        const limit = window.innerWidth <= 768 ? 7 : 12;
        const start = (page - 1) * limit;

        const res = await fetch(
          `https://www.teluguone.com/comedy/comedyContentCategoryJson.php?start=${start}&limit=${limit}&cat_id=${catId}`
        );

        if (!res.ok) throw new Error("API failed");

        const result = await res.json();
        setDataList(result.comedy_category || []);
        setError(null);

      } catch (err) {
        setError(err.message);
        setDataList([]);
      } finally {
        setLoading(false);
         isFirst.current = false
      }
    };

    setDataList(null)
    fetchData();

  }, [catId, page, hydrating]);

 
    



  /* ---------------- PAGINATION ---------------- */
  const renderPagination = () => {

    if (!totalPages) return null;
    const pagesPerBlock = 5;
    const startPage = Math.floor((page - 1) / pagesPerBlock) * pagesPerBlock + 1;
    const endPage = Math.min(startPage + pagesPerBlock - 1, totalPages);
    const pages = [];

    
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`pagination-btn ${i === page ? "cat-page-active" : ""}`}
          onClick={() => setPage(i)}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="cat-pagination">
        <button
          className={`${page !== 1 ? 'cat-pagination-arrow' : ''}`}
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          disabled={page === 1}
        >
          &laquo; Prev
        </button>

        {pages}

        <button
          className="cat-pagination-arrow"
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={page === totalPages}
        >
          Next &raquo;
        </button>
      </div>
    );
  };

  /* ---------------- RENDER ---------------- */
  return (
    <div className="comedy-contents-page" style={{minHeight: `${(dataList && dataList.length > 6) ? '800px' : '400px' }`}}>

      <Helmet>
        <title>Telugu Comedy | Telugu Jokes | Telugu Comedy Stories | Telugu Cartoon Jokes | Telugu comedy videos</title>
      </Helmet>

      <ComedyBreadCrumb breadCrumb={breadCrumb} />
       {(loading || hydrating) && !mobile &&
            Array(mobile ? 7 : 12)
              .fill("0")
              .map((__, index) => (
                
                  <div className="comedy-contents-card" key={index}>
                    
                    <img
                      src="/comedy/assets/images/error_img.webp"
                      alt="small-img"
                      className="comedy-contents-card-img"
                    />
                   <Skeleton type="title" />
                  </div>
              
              ))}

           {(loading) && mobile &&  Array(mobile ? 7 : 12).fill('0').map((__,index) => 
                              
                                
                                      <div className='comedy-mob-card' key={index}> 
                                         <div className='comedy-mob-card-img-container'>
                                             <img  src={`/comedy/assets/images/error_img.webp`} alt="comedy-mob-card-img" />
                                         </div> 
                                          <div className='d-flex flex-column  comedy-mob-card-title-container'>
                                             <Skeleton type={'title'} />
                                              <Skeleton type={'paragraph'} />
                                          </div>
                                    </div>
                                
                            )} 

      {dataList && dataList.length > 0 &&
        dataList.map((item, index) =>
          item.msg ? null : mobile ? (
                            <div className={`comedy-mob-card ${hydrating ? 'ssr-hidden' : ''}`} key={index} >
                            
                             <Link to={item.url_link ? item.url_link.substring(item.url_link.indexOf('/content')) : '/'}  >
                           
                                <div className='comedy-mob-card-img-container'>
                                <img   loading={ index === 0 ? "eager" : index < 3 ? "auto" : "lazy"}
                       fetchpriority={index === 0 ? "high"  : index < 4 ? "auto"  : "low" } src={item.stimg ? item.stimg : '/comedy/assets/images/error_img.webp'} alt="comedy-mob-card-img" />
                                </div>
                                <div className='comedy-mob-card-title-container'>
                                <h4 className={`comedy-mob-card-title ${isTelugu(item.title) && item.title ? "comedy-mob-card-title-tl" : 'comedy-mob-card-title-en'}`}>{item.title ? item.title : ''}</h4>
                                <p    dangerouslySetInnerHTML={{__html : (item.description ? item.description : '')}} />{<button type='button'>View Content</button>}</div>
                              
                             
                             </Link>
                         
                         
                   </div>
          ) : (
            <ComedyContentsCard key={index} item={item} index={index} />
          )
        )
      }

      {!loading && !error && !hydrating && dataList && dataList.length === 0 && (
        <p className="no-more">No More Data......</p>
      )}

      {!loading && !hydrating &&
        ((mobile && dataList && dataList.length === 7) ||
          (!mobile && dataList && dataList.length === 12)) &&
        renderPagination()
      }

      {error && <div className="json-loading-error-div">
               <img loading="eager" src="/comedy/assets/images/json_error.png" alt="json_error" />
              </div>
        }
        <PageAds  mobile={mobile} containerRef={containerRef} />
    </div>
  );
};

export default ComedyContentsCat;
